import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface FilterPillProps {
  label: string;
  active?: boolean;
  disabled?: boolean;
  onToggle?: () => void;
  onRemove?: () => void;
  showRemove?: boolean;
  className?: string;
}

export function FilterPill({
  label,
  active = false,
  disabled = false,
  onToggle,
  onRemove,
  showRemove = false,
  className,
}: FilterPillProps) {
  const handleClick = () => {
    if (disabled) return;
    if (showRemove && onRemove) {
      onRemove();
    } else if (onToggle) {
      onToggle();
    }
  };

  return (
    <Button
      type="button"
      variant={active ? 'default' : 'outline'}
      size="sm"
      aria-pressed={active}
      onClick={handleClick}
      disabled={disabled}
      className={className}
    >
      <span>{label}</span>
      {showRemove && active && (
        <X className="h-3 w-3" />
      )}
    </Button>
  );
}
